import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "field" }
const _hoisted_2 = { class: "intent-picker" }
const _hoisted_3 = { class: "intent-picker__trigger button has-text-left" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "intent-picker__trigger-placeholder"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "intent-picker__intent-name" }
const _hoisted_8 = { class: "intent-picker__dropdown-item" }

import { IntentListItemViewModel } from '@/features/bots/models/intents/intentListItemViewModel';
import DropDownMenu from '@/shared/components/dropDownMenu/DropDownMenu.vue';
import AddIcon from 'vue-material-design-icons/Plus.vue';
import FaqAddIntentModal from '@/features/bots/components/designer/FaqAddIntentModal.vue';
import { computed, PropType, ref, watch } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'FaqIntentPicker',
  props: {
  intents: {
    type: Array as PropType<IntentListItemViewModel[]>,
    required: true,
  },
  faqName: {
    type: String,
    required: true,
  },
  intentId: {
    type: String,
  },
},
  emits: ["input"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const selectedIntent = ref<Partial<IntentListItemViewModel> | null>(null);
const showAddIntentModel = ref(false);

const intentsForFaq = computed(() =>
  props.intents
    .filter((intent: IntentListItemViewModel) => intent.id !== 'None')
    .sort((a: IntentListItemViewModel, b: IntentListItemViewModel) => a.title.localeCompare(b.title)),
);

watch(
  () => props.intentId,
  () => {
    if (selectedIntentIsNewIntent()) {
      return;
    }
    const matchingIntentOnId = props.intents.find((i) => i.id === props.intentId);
    if (matchingIntentOnId) {
      return selectIntent(matchingIntentOnId);
    }
    const matchingIntentOnName = props.intents.find((i) => i.title === props.faqName);
    if (matchingIntentOnName) {
      return selectIntent(matchingIntentOnName);
    }
    return selectIntent({ title: props.faqName });
  },
  { immediate: true },
);

function addedIntent(intentTitle: string) {
  const existingIntent = props.intents.find((i) => i.title === intentTitle);
  if (existingIntent) {
    selectIntent(existingIntent);
  } else {
    selectIntent({ title: intentTitle });
  }
}

function selectIntent(intent: Partial<IntentListItemViewModel>) {
  if (intent !== selectedIntent.value) {
    selectedIntent.value = intent;
    emitSelectedIntent();
  }
}

function selectedIntentIsNewIntent() {
  return (
    selectedIntent.value !== null &&
    selectedIntent.value?.id === undefined &&
    selectedIntent.value?.title !== props.faqName
  );
}

function emitSelectedIntent() {
  emit('input', selectedIntent.value!);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("h2", null, [
        _createElementVNode("strong", null, "Intent")
      ], -1)),
      _createVNode(DropDownMenu, { dropDownIcon: "none" }, {
        trigger: _withCtx(() => [
          _createElementVNode("button", _hoisted_3, [
            _createElementVNode("div", null, [
              (selectedIntent.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(selectedIntent.value.title), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_5, "Select an intent"))
            ])
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(intentsForFaq.value, (intent) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "intent-picker__dropdown-item",
                key: intent.id
              }, [
                _createElementVNode("a", {
                  onClick: ($event: any) => (selectIntent(intent))
                }, [
                  _createElementVNode("div", _hoisted_7, _toDisplayString(intent.title), 1)
                ], 8, _hoisted_6)
              ]))
            }), 128)),
            _cache[3] || (_cache[3] = _createElementVNode("hr", { class: "dropdown-divider" }, null, -1)),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("a", {
                class: "intent-picker__add-intent",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (showAddIntentModel.value = true))
              }, [
                _createVNode(AddIcon, { class: "icon-1-3x" }),
                _cache[2] || (_cache[2] = _createTextVNode(" Add new intent "))
              ])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    (showAddIntentModel.value)
      ? (_openBlock(), _createBlock(FaqAddIntentModal, {
          key: 0,
          onCreate: addedIntent,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (showAddIntentModel.value = false))
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})